module.exports = __webpack_public_path__ + "media/images/digivent/avatars/AVATAR-02-bd3f83f3b8b6114928faf155d8317ae0.png";